import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 4.8.",
  "description": "",
  "published": "2011-09-04T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-4-8/swizec/2357"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.flickr.com/photos/54276164@N00/34630357"
        }}><img parentName="a" {...{
            "src": "https://swizec.com/blog/wp-content/uploads/2011/09/34630357_a5b1c00f5d_m.jpg",
            "alt": "note",
            "title": "note"
          }}></img></a></li>
    </ul>
    <p>{`Today I learned that the next time I think "I should write this down for later" `}<em parentName="p">{`I will fucking write it down`}</em>{`. Because today I learned something awesome, and I was like "Oh this will be perfect for the evening blog! I should write it down".`}</p>
    <p>{`My very next thought was that it's too awesome and I will surely remember it.`}</p>
    <p>{`I didn't.`}</p>
    <p>{`At least now I know what all those moleskines I keep carrying around are for. Writing down this sort of crap damn it. And I might just be repeating this so it imprints in my brain like a pavlovian reflex of some sort. Write shit down Swizec!`}</p>
    <p>{`Another thing I learned is that when you try to add my blog into `}<a parentName="p" {...{
        "href": "http://www.google.com/reader",
        "title": "Google Reader"
      }}>{`Google Reader`}</a>{` it doesn't automagically work even though the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/RSS",
        "title": "RSS"
      }}>{`RSS`}</a>{` links are right there in the . Seems the first link is empty and that's somehow very wrong and horrible.`}</p>
    <p>{`Thanks to Jimi Malcolm for letting me know. I'd link to your twitter or something, but don't know it.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://theengagingbrand.typepad.com/the_engaging_brand_/2011/08/why-the-web-is-for-lazy-people.html"
        }}>{`Why the Web is For Lazy People`}</a>{` (theengagingbrand.typepad.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://bardicblogger.wordpress.com/2011/09/03/finding-the-best-time-to-write/"
        }}>{`Finding the Best Time to Write`}</a>{` (bardicblogger.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://dianneguthmuller.com/2011/09/03/some-lessons-are-learned-the-hard-way%25e2%2580%2594daniel-425-27-2/"
        }}>{`Some Lessons are Learned the Hard Way - Daniel 4:25-27`}</a>{` (dianneguthmuller.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.neophilic.com/b2evo/blogs/blog4.php/2011/09/02/programming-isnt-fun-any-more"
        }}>{`Programming Isn't Fun Any More`}</a>{` (neophilic.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=791f2ad4-2182-4a3f-80e5-a47461ea82d4",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      